import DataTable from 'datatables.net-bs5';
import 'unpoly';

const up = window.up;

up.compiler("#count_table", function() {
  const table = new DataTable('#count_table', {
    retrieve: true,
    paging: false,
    info: false,
    searching: false,
    ordering: true,
    columnDefs: [
      {
        type: 'numeric',
        targets: [1, 2, 3, 4, 5, 6, 7, 8, 9],
        // Change default sort ordering behavior, so that when clicked on the
        // first time, we sort by descending first (since if we're sorting by
        // that column, we likely want to see the states with the most stations
        // first, not the least).
        asSorting: ['desc', 'asc'],
        render: function(data, type) {
          if(type === 'sort' && data) {
            // The electric data is a string representing the stations and
            // charging ports (eg, '1733/5091'). Run it through parseInt, so
            // we only sort based on the first number (station counts), and
            // without comma thousand separators.
            return parseInt(data.replace(',', ''), 10);
          } else {
            return data;
          }
        }
      }
    ],
  });

  // Return destructor for unpoly to cleanup.
  return table.destroy;
});

// Handling the `type=date` inputs without an explicit Submit button on the form
// is tricky because of how browsers trigger the "change" event while the user
// is still potentially typing a date. So this requires jumping through some
// hoops to try and maintain auto-submit behavior, while also maintaining
// accessibility.
//
// See:
// https://stackoverflow.com/q/40762549
// https://stackoverflow.com/q/43684506
const dateEl = document.querySelector('input[name=date]');
const origDateValue = dateEl.value;
function dateChange() {
  // If it's a valid date, and it doesn't match the value on load (since we're
  // triggering on blur, we may have triggers that aren't actual changes), then
  // submit the form.
  if (dateEl.checkValidity() && dateEl.value !== origDateValue) {
    up.submit(document.getElementById('stations_form'));
  }
}
function dateKeydown(event) {
  // If the user types any digits, then this indicates they're probably trying
  // to type a date, so remove the "change" listener, since for `type=date`
  // inputs, it will trigger while the user is still trying to type a date.
  if (/^[0-9]$/.test(event.key)) {
    dateEl.removeEventListener('change', dateChange);
  }

  // Always trigger a change submit if they hit "enter."
  if (event.keyCode === 13) {
    dateChange();
  }
}
function dateClick() {
  // If the user clicks on the date input, then be sure to add back in the
  // "change" listener, since it's possibly been removed by the keydown handler
  // (and a click may indicate the user has given up on typing and is switching
  // back to the calendar input).
  dateEl.removeEventListener('change', dateChange);
  dateEl.addEventListener('change', dateChange);
}

dateEl.addEventListener('change', dateChange);
dateEl.addEventListener('keydown', dateKeydown);
dateEl.addEventListener('click', dateClick);
dateEl.addEventListener('blur', dateChange);
